export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "search.worker-ef58af70ebfeb2901041.worker.js");
}
